// Utilitaire API URL - detecte automatiquement le bon backend
// Sur tcprotrader.com (production) -> utilise le meme domaine (relative URL)
// Sur preview.emergentagent.com -> utilise REACT_APP_BACKEND_URL

function getApiUrl() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('tcprotrader.com')) {
      return '';
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE = getApiUrl();
export default API_BASE;
